/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_Source_OnlineInputs */

const vi_online_price_source_online = /** @type {(inputs: Online_Price_Source_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá Online`)
};

/**

* @param {Online_Price_Source_OnlineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_source_online = /** @type {((inputs?: Online_Price_Source_OnlineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Source_OnlineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_source_online(inputs)
});